import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import DescargarNegro from "../../icons/descargar-negro.svg";
import { withRouter } from "../../providers/withRouter";
import {
  createDeclRes,
  getDeclResOfSupplier,
  getAaffSuppServ,
  updateDeclRes,
  validateDeclRes,
} from "../../services";
import {
  abrirArchivo
} from "../../providers/documentos";
import { UsuarioContext } from "../../providers/userContext";
import { CircularProgress } from "@mui/material";
import { useSwal } from "../../utilities/showSwalFireAlert";
import TabledeclHelper from "./declResHelper";
import { useToastHook } from "../../utilities/showToast";

const DeclRes = (props) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext);
  const [aaff, setAAFF] = useState([]);
  const [recargar, setRecargar] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const showAlert = useSwal();
  const [uploadedFiles, setUploadedFiles] = useState({});
  const { showToast } = useToastHook();
  
  const fetchData = async () => {
    let res = await getDeclResOfSupplier(props.nifProv);

    if (!Array.isArray(res)) {
      res = [];
    }

    // Si getDeclResOfSupplier devuelve vacío pero el proveedor tiene declres, obtener la lista de AAFFs y cruzar con los datos de declres del proveedor
    if (res.length === 0 && props.proveedor?.declres?.length > 0) {
      try {
        const aaffList = await getAaffSuppServ(props.nifProv);
        if (Array.isArray(aaffList) && aaffList.length > 0) {
          res = aaffList.map(aaff => ({
            ...aaff,
            declRes: props.proveedor.declres.find(dr => dr.aaff_id === aaff.id) || null
          }));
        }
      } catch (error) {
        console.log("Error en fallback de AAFF para declRes:", error);
      }
    }

    setAAFF(res);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [recargar]);

  const handleSubirDocsCallback = () => {
    setRecargar(!recargar);
  };

  const handlePendingClick = async (row) => {
    try {

      if (user.rol != "SUPP") {
        abrirArchivo(row.declRes?.ruta);
        const ruta = row.declRes?.ruta;
        const id = row.declRes?.id;
        const nif = row.nif;

        const alertShow = await showAlert({
          title: t('documents.whatDoYouWant'),
          text: t('documents.notValidatedWarning'),
          confirmButtonText: t('documents.validate'),
          cancelButtonText: t('actions.cancel'),
          denyButtonText: t('documents.notValidate'),
          confirmButtonColor: "#7bc977",
          cancelButtonColor: "rgb(130, 130, 130)",
          denyButtonColor: "#FF5252",
        });

        if (alertShow.isConfirmed) {
          const comprobar = await validateDeclRes(nif, id, { validado: true });

          if (comprobar) {
            showToast(t('messages.updatedSuccessfully'), { type: "success" });
            handleSubirDocsCallback(comprobar);
          }
        } else if (alertShow.isDenied) {
          const novalidar = await validateDeclRes(nif, id, { validado: false });

          if (novalidar) {
            handleSubirDocsCallback(novalidar);
          }
        }
      }
    } catch (error) {
      console.log(error);
      // showToast("Error al actualizar los datos", { type: "error" });
    }
  };

  const handleViewClick = (ruta) => {
    // console.log("Ver archivo:", ruta);
    abrirArchivo(ruta);
  };

  const handleAttachFile = async (row, file, inputRef) => {
    // console.log(row.id);
    // console.log(row);

    // console.log(row.declRes?.id, file);
    const declResId = row.declRes?.id;
    // console.log(declResId);

    // Actualiza el estado con el archivo subido
    setUploadedFiles((prev) => ({
      ...prev,
      [row.id]: file, // Asociar archivo a la fila
    }));

    // Restablecer el valor del input para permitir seleccionar el mismo archivo
    if (inputRef && inputRef.current) {
      inputRef.current.value = null;
    }

    if (declResId) {
      //actualizar
      try {
        const updatedata = await updateDeclRes(file, declResId);
        if (updatedata) {
          showToast(t('messages.uploadedSuccessfully'), { type: "success" });
          handleSubirDocsCallback(updatedata);
        }
      } catch (error) {
        console.log(error);
        showToast(t('messages.error'), { type: "error" });
      }
    } else {
      try {
        //crear
        const create = await createDeclRes(file, props.nifProv, {
          aaff_id: row.id,
        });
        if (create) {
          showToast(t('messages.uploadedSuccessfully'), { type: "success" });
          handleSubirDocsCallback(create);
        }
      } catch (error) {
        console.log(error);
        showToast(t('messages.error'), { type: "error" });
      }
    }
    // console.log(uploadedFiles);

    // const createDeclRes = await createDeclRes();
    // updateDeclRes(el.files[0], idDeclRes)
  };

  return (
    <>
      <div className="gridCard" style={{ position: "relative" }}>
        <div className="gridHead">{t('responsibleDeclarations.title')}</div>
        <div style={{ overflow: "scroll", maxHeight: 750 }}>
          {user.rol === "SUPP" ? (
            <div
              className="gridSubhead"
              style={{ display: "flex", justifyContent: "end" }}
            >
              <a
                href="/files/Modelo-Declaracion-Responsable.pdf"
                download="Modelo-Declaracion-Responsable.pdf"
              >
                <span style={{ marginRight: 10 }}>{t('responsibleDeclarations.downloadTemplate')}</span>{" "}
                <img
                  src={DescargarNegro}
                  width={12}
                  alt={t('responsibleDeclarations.downloadAlt')}
                />
              </a>
            </div>
          ) : null}

          {isLoading ? (
            <CircularProgress
              style={{
                height: 40,
                width: 40,
                color: "#92004D",
                position: "absolute",
                top: "65%",
                left: "5%",
              }}
            />
          ) : aaff.length === 0 ? (
            <p
              style={{
                fontSize: "14px !important",
                textAlign: "center",
                padding: "20px",
              }}
            >
              {t('responsibleDeclarations.noDeclarations')}
            </p>
          ) : (
            <table style={{ margin: 15 }}>
              <thead>
                <tr
                  style={{
                    fontSize: 11,
                    textAlign: "center",
                    margin: 0,
                    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                    fontWeight: 400,
                    lineHeight: 1.5,
                    letterSpacing: "0.00938em",
                  }}
                >
                  <th></th>
                  <th></th>
                  <th style={{ margin: 5 }}>{t('actions.view')}</th>
                  <th>{t('actions.upload')}</th>
                </tr>
              </thead>
              <tbody>
                <TabledeclHelper
                  rows={aaff}
                  onPendingClick={handlePendingClick}
                  onViewClick={handleViewClick}
                  onAttachFile={handleAttachFile}
                  showAlert={showAlert}
                  user={user}
                />
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(DeclRes);
